export type PricingPlan = "monthly" | "annual";

export const PLAN_SLUGS: Record<PricingPlan, "anual" | "mensual"> = {
  annual: "anual",
  monthly: "mensual",
};

export type PlanSlug = (typeof PLAN_SLUGS)[PricingPlan];

export function parsePlanSlug(slug: string): PricingPlan | null {
  if (slug === PLAN_SLUGS.annual) return "annual";
  if (slug === PLAN_SLUGS.monthly) return "monthly";
  return null;
}

export function planSlugFor(plan: PricingPlan): PlanSlug {
  return PLAN_SLUGS[plan];
}

export function registroHref(plan: PricingPlan): string {
  return `/registro/${PLAN_SLUGS[plan]}`;
}

export function planSelectionHref(plan: PricingPlan): string {
  return `/seleccionar-plan?plan=${plan}`;
}
